import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-64f8afee"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wrap fs-s"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fw-b fs-l pb-20"
}, "碳手印项目库", -1));
import ResList from '../components/ResList.vue';
import request from '@/utils/request.js';
import { ref, onMounted } from 'vue';
export default {
  __name: 'VideoBase',
  setup(__props) {
    let listData = ref([]);
    function getList() {
      request({
        url: '/project_base.json',
        method: 'get'
      }).then(res => {
        listData.value = res.data;
      });
    }
    // const acList = [
    //     { title: '浙江省行政中心', src: require('@/assets/project_e1.jpg') },
    //     { title: '国网浙江利有大厦', src: require('@/assets/project_e2.jpg') },
    //     { title: '浙江建设科技研发中心', src: require('@/assets/project_e3.png') },
    //     { title: '北大附属朝阳未来学校', src: require('@/assets/project_e4.jpg') },
    //     { title: '北京十一学校昌平小学', src: require('@/assets/project_e5.png') },
    //     { title: '华北电力大学实验室', src: require('@/assets/project_e6.png') },
    //     { title: '小米科技园海淀园区', src: require('@/assets/project_e7.jpg') },
    //     { title: '小米科技园亦庄园区', src: require('@/assets/project_e8.png') },
    //     { title: '华大北斗股份有限公司', src: require('@/assets/project_e9.png') },
    //     { title: '绿城·青亭', src: require('@/assets/project_e10.png') },
    //     { title: '华润·七里渠', src: require('@/assets/project_e11.png') },
    //     { title: '天鸿置业·绿溢广场', src: require('@/assets/project_e12.png') }

    // ]
    onMounted(() => {
      // initVideo()
      getList();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(ResList, {
        list: _unref(listData)
      }, null, 8, ["list"])]);
    };
  }
};